import { SourceView } from '@/types';

import { BlueJApi } from './blue-j-api';

export class SourceApi extends BlueJApi {
  private basePath = 'api';

  private _getSourceContent = this.createFetch<null, SourceView, { id: string, type: string }>((params) => {
    const queryParams = new URLSearchParams({ id: params.id.split('?')[0], type: params.type });
    return `${this.basePath}/content-management/content?${queryParams.toString()}`;
  }, 'GET');

  public async getSourceContent(id: string, type: string): Promise<SourceView> {
    return this._getSourceContent(null, { id, type }).parsedResponse();
  }
}
